import { useState, useEffect } from 'react';

const usePagePhotos = (pageName) => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE = process.env.REACT_APP_USE_CMS === 'true' 
    ? process.env.REACT_APP_API_URL || 'http://localhost:3001/api'
    : null;

  useEffect(() => {
    const fetchPhotos = async () => {
      // If CMS is not enabled, don't fetch
      if (!API_BASE) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/page-photos/${pageName}`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        setPhotos(data);
        setError(null);
      } catch (err) {
        console.warn(`Failed to fetch photos for ${pageName}:`, err);
        setError(err);
        setPhotos([]);
      } finally {
        setLoading(false);
      }
    };

    if (pageName) {
      fetchPhotos();
    }
  }, [pageName, API_BASE]);

  // Helper function to get photo by key
  const getPhoto = (photoKey, fallbackUrl = null) => {
    // Only look for CMS photos if we have data loaded
    if (photos && Array.isArray(photos) && photos.length > 0) {
      const photo = photos.find(p => p.photo_key === photoKey && p.is_active);

      if (photo && photo.photo_url) {
        return {
          url: photo.photo_url,
          alt: photo.alt_text || '',
          caption: photo.caption || ''
        };
      }
    }

    // Return null - let the component handle the fallback
    return null;
  };

  // Helper function to get all active photos sorted by display order
  const getActivePhotos = () => {
    return photos
      .filter(photo => photo.is_active)
      .sort((a, b) => a.display_order - b.display_order)
      .map(photo => ({
        ...photo,
        url: photo.photo_url
      }));
  };

  return {
    photos,
    loading,
    error,
    getPhoto,
    getActivePhotos,
    isUsingCMS: !!API_BASE
  };
};

export default usePagePhotos;